import React from 'react'
import './contact.css'

const Contact = ({ handleClickBack, isLogin }) => (
  <div className='contact'>
    <div className='contact-header'>
      <h1>Fale conosco</h1>
      <form>
        { !!isLogin &&
          <div className='field'>
            <label className='label'>Nome</label>
            <div className='control'>
              <input className='input' type='text' />
            </div>
          </div>
        }
        { !!isLogin &&
          <div className='field'>
            <label className='label'>Email</label>
            <div className='control'>
              <input className='input' type='email' />
            </div>
          </div>
        }
        { !!isLogin &&
          <div className='field'>
            <label className='label'>Telefone</label>
            <div className='control'>
              <input className='input' type='text' />
            </div>
          </div>
        }
        <div className='field'>
          <label className='label'>Selecione o assunto:</label>
          <div className='control'>
            <div className='select is-fullwidth'>
              <select>
                <option>Problemas técnicos</option>
                <option>Não encontrei um livro</option>
                <option>Não encontrei uma escola</option>
                <option>Outros</option>
              </select>
            </div>
          </div>
        </div>

        <div className='field'>
          <label className='label'>Por favor, descreva aqui o seu contato:</label>
          <div className='control '>
            <textarea className='textarea' />
          </div>
        </div>

        <div className='field is-grouped'>
          <div className='control'>
            <button className='button is-primary'>Enviar</button>
          </div>
          <div className='control'>
            <button onClick={handleClickBack} type='button' className='button is-link'>Cancelar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
)

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact/index.js